import {ApplicationPolicy} from './application_policy';
import {ProcessDefinitionVersion, WorkspaceMembershipRole} from '@paperlessio/sdk/api/models';

export class ProcessDefinitionVersionPolicy extends ApplicationPolicy {
  record: ProcessDefinitionVersion;

  index(): boolean {
    return this.workspace_membership.at_least(WorkspaceMembershipRole.admin);
  }

  show(): boolean {
    return this.workspace_membership.at_least(WorkspaceMembershipRole.admin);
  }

  create(): boolean {
    return this.workspace_membership.at_least(WorkspaceMembershipRole.admin);
  }

  update(): boolean {
    return this.workspace_membership.at_least(WorkspaceMembershipRole.admin);
  }

  destroy(): boolean {
    return this.workspace_membership.at_least(WorkspaceMembershipRole.admin);
  }
}
